import React from "react";
import { useEffect, useState, useContext } from "react";
import { ListGroup } from "react-bootstrap";
import { useAuth0 } from "@auth0/auth0-react";
import { useTranslation } from "react-i18next";
import { LogoutIcon } from "../../../external/sx-icons/src/icons";

const LoginButton = (props: {
  id?: string;
  flat?: boolean;
  icon?: boolean;
  className?: string;
  alternativelabel?: string;
  isAuthenticated?: any;
  isLoading: any;
  loginWithRedirect?: any;
  logout?: any;
}) => {
  const { isAuthenticated, isLoading, loginWithRedirect, logout } = props;
  const [showButton, setShowButton] = useState(false);
  const { t, i18n } = useTranslation();

  useEffect(() => {
    if (isLoading) {
      setShowButton(true);
    } else if (isLoading === false) {
      setShowButton(true);
    }
  }, [isLoading, isAuthenticated]);

  const setRedirectUrl = () => {
    window.localStorage.setItem("url", window.location.pathname);
  };

  return (
    <>
      {showButton && !props.flat && (
        <button
          className={`primary-btn ${props.className}`}
          id={props.id}
          onClick={async () => {
            if (isAuthenticated) {
              logout({ logoutParams: { returnTo: window.location.origin } });
            } else {
              setRedirectUrl();
              loginWithRedirect();
            }
          }}
        >
          {props.isAuthenticated
            ? t("general.log_out") + ""
            : props.alternativelabel
              ? props.alternativelabel
              : t("general.sign_in") + ""}
        </button>
      )}
      {showButton && props.flat && (
        <ListGroup.Item
          className={`"navbar-btn-flat ${props.className}"`}
          id={props.id}
          onClick={() => {
            if (isAuthenticated) {
              logout();
            } else {
              setRedirectUrl();
              loginWithRedirect();
            }
          }}
        >
          {props.icon && <LogoutIcon />}
          {isAuthenticated ? t("general.log_out") + "" : t("general.sign_in") + ""}
        </ListGroup.Item>
      )}
    </>
  );
};

export default LoginButton;
